import { useLayoutEffect } from 'react';
/**
 * Enable auto resize textarea when text changed.
 *
 * @param props - Props for the auto resize.
 * @param inputRef - Ref to the textarea html element.
 */
export function useAutoResize(props, inputRef) {
    var value = props.value, enabled = props.enabled;
    useLayoutEffect(function () {
        if (inputRef.current && enabled) {
            var input = inputRef.current;
            input.style.height = 'auto';
            input.style.height = input.scrollHeight + "px";
        }
    }, [inputRef, value, enabled]);
}
